import { IBaseBenefitTemplate, IBenefitTemplate } from 'types/income';
import { convertUploadedFile } from 'store/files';
import { converters as tableConverters } from 'store/table';
import {
  BaseBenefitTemplate,
  BenefitTemplate,
} from './benefit-templates.types';
import { loaders } from './benefit-templates.loaders';

export const convertBaseBenefitTemplate = (
  template: IBaseBenefitTemplate,
): BaseBenefitTemplate => {
  return {
    id: template.id,
    name: template.name,
    category: template.type,
    status: template.status,
    copiesMade: template.copiesMade ?? NaN,
    modifiedAt: template.modificationDate,
  };
};

export const convertBenefitTemplate = (
  template: IBenefitTemplate,
): BenefitTemplate => {
  return {
    ...convertBaseBenefitTemplate(template),
    thumbnailId: template.thumbnailId,
    thumbnail: template.thumbnail,
    supportedCountries: template.supportedCountries,
    defaultLanguage: template.defaultLanguage,
    supportedLanguages: template.supportedLanguages,
    translations: template.translations.map((trans) => ({
      language: trans.language,
      title: trans.title,
      description: trans.description,
      image: trans.image ? convertUploadedFile(trans.image) : null,
      links: trans.links.map((link, i) => ({
        index: i,
        name: link.name,
        url: link.url,
      })),
      attachments: trans.attachments.map((attachment) => ({
        id: attachment.id,
        name: attachment.name,
        fileId: attachment.fileId,
        file: attachment.file,
        index: attachment.index,
      })),
      faq: trans.faq.map((f, i) => ({
        index: i,
        question: f.question,
        answer: f.answer,
      })),
    })),
  };
};

const convertBenefitTemplates = (
  templates: IBenefitTemplate[],
): BenefitTemplate[] => {
  return templates.map(convertBenefitTemplate);
};

export const converters = {
  getBenefitTemplates: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getBenefitTemplates>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertBenefitTemplates(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
};
